import { render, staticRenderFns } from "./GraficoServiciosbasicos.vue?vue&type=template&id=22d7d9b7&"
import script from "./GraficoServiciosbasicos.vue?vue&type=script&lang=js&"
export * from "./GraficoServiciosbasicos.vue?vue&type=script&lang=js&"
import style0 from "./GraficoServiciosbasicos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports